import { Component, OnInit, ViewEncapsulation, ViewChild, Input, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { aggregateBy } from '@progress/kendo-data-query';
import { GridComponent } from '@progress/kendo-angular-grid';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SelectEvent, FileRestrictions } from '@progress/kendo-angular-upload';
import { AdjustmentService } from 'src/app/shared/services/adjustments/adjustment.service';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';

@Component({
  selector: 'app-adjustment-record',
  templateUrl: './adjustment-record.component.html',
  styleUrls: ['./adjustment-record.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AdjustmentRecordComponent implements OnInit {

  constructor(
    private adjustmentService: AdjustmentService,
    private usersService: UsersService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService
  ) { }

  @ViewChild(GridComponent) private grid: GridComponent;
  gridData: any;
  fileUploadData: any;
  config: any;
  adjustmentAmount: any;
  total: any;
  uploadFile: any;
  contributionWithheld: boolean;
  submitAdj: boolean;
  newRecord: boolean;
  existingRecord: boolean;
  isInfoAvailable: boolean;
  noBankInfo: boolean;
  validFileExt = false;
  displayload = false;
  min = 0;
  maxAddAmount = 8999999.99;
  contType = '';
  isCurrentFY = '';
  isWithheldCont = '';
  aggregates: any[] = [{ field: 'adjustmentAmount', aggregate: 'sum' }];
  fileRestrictions: FileRestrictions = {
    allowedExtensions: ['.xlsx']
  };

  @Output() recordSavedResponse = new EventEmitter<any>();
  @Output() resetEvent = new EventEmitter<boolean>();
  @Output() cancelEvent = new EventEmitter<boolean>();
  @Input() set isBankInfoAvail(bankInfoExist) {
    this.isInfoAvailable = bankInfoExist;
  }
  @Input()
  set adjustmentsRecord(records) {
    this.initialAdjRecordCheck(records);
  }

  ngOnInit() {
    this.config = this.readConfigService.getAdjustmentFileUpload();
  }

  initialAdjRecordCheck(records) {
    if (records) {
      this.existingRecord = records.id === 1;
      if (records.id > 0) {
        this.newRecord = false;
        this.existingRecord = true;
        this.contType = '';
      } else {
        this.contType = '';
        this.isCurrentFY = '';
        this.isWithheldCont = '';
        this.noBankInfo = false;
        this.newRecord = records.id === 0;
        if (this.fileUploadData && this.fileUploadData.length > 0) {
          this.onClearButtonClick(this.uploadFile);
        }
      }
      this.gridData = records.system;
      this.totalAdjustmentValue();
      this.notificationService.setUpLoading(false);
    }
  }

  btndisable() {
    if ((this.isWithheldCont.length > 0 || this.isCurrentFY.length > 0)
              && !(this.fileUploadData
              && this.fileUploadData.length > 0 && this.validFileExt)) {
      return true;
    } else if (this.isWithheldCont === 'yes' && this.contType === 'positive'
              && this.gridData.some(x => x.adjustmentAmount > this.maxAddAmount
              || this.min > x.adjustmentAmount)) {
      return true;
    } else if (this.isCurrentFY === 'yes' && this.contType === 'negative' &&
              (this.gridData.some(x => x.adjustmentAmount > this.min)
              || !this.gridData.some(x => x.adjustmentAmount < this.min) )) {
      return true;
    }
    return false;
  }

  gridVisibilityCheck() {
    return ((this.isWithheldCont === 'yes' && this.contType === 'positive') || this.isCurrentFY === 'yes' || this.existingRecord);
  }

  keytab(event: any) {
      const target = event.target || event.srcElement;
      const actuallValue = target.getAttribute('aria-valuenow');
      if (actuallValue) {
        if (actuallValue.indexOf('.') < 8) {
          target.setAttribute('maxLength', 10);
        } else {
          target.setAttribute('maxLength', 7);
        }
      }
  }

  onAdjustmentChange(value: any, dataItem: any) {
    value = parseFloat((value || 0).toFixed(2));
    if (this.contType === 'positive' || this.contType === 'negative') {
      if (dataItem && this.gridData) {
        this.gridData.forEach((element, index) => {
          if (element.id === dataItem.id) {
            this.gridData[index].adjustmentAmount = value;
          }
          this.totalAdjustmentValue();
        });
      }
    }
  }

  totalAdjustmentValue() {
    this.total = aggregateBy(this.gridData, this.aggregates);
  }

  submitAdjustment() {
      this.adjustmentAmount = {};
      this.displayload = true;
      const gridElement = this.gridData.filter(x => x.adjustmentAmount !== 0);
      if (gridElement.length > 0) {
        this.adjustmentAmount = JSON.stringify(gridElement);
      }
      this.notificationService.setUpLoading(true);
      const inputData = {
        userInfo: JSON.stringify(this.usersService.UserInfo()),
        uploadFile: this.fileUploadData[0],
        adjustmentDetails: this.adjustmentAmount,
        contributionWithheld: this.isWithheldCont === 'yes',
        isCurrentFY: this.isCurrentFY === 'yes',
        isDebitInvoice: this.contType === 'positive'
      };
      this.adjustmentService.submitAdjustments(inputData)
      .subscribe((response: any) => {
        if (response && response.success) {
          this.recordSavedResponse.emit(response);
          this.onClearButtonClick(this.uploadFile);
        } else {
          this.isWithheldCont = '';
          this.isCurrentFY = '';
          this.notificationService.setErrorNotification();
        }
        this.submitAdj = false;
        this.displayload = false;
        this.contType = '';
        this.notificationService.setUpLoading(false);
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.displayload = false;
        this.submitAdj = false;
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  onClearButtonClick(upload: any) {
    this.fileUploadData = [];
    this.isCurrentFY = '';
    this.isWithheldCont = '';
    upload.clearFiles();
  }

  onSelectEvent(e: SelectEvent, upload) {
    this.uploadFile = upload;
    if (e && e.files && e.files.length > 0) {
      this.fileUploadData = e.files;
    }
    const validationErrors = e.files[0].validationErrors;
    this.validFileExt = !(validationErrors && validationErrors.length > 0);
  }

  closePopup() {
    this.displayload = false;
    this.submitAdj = false;
  }

  onRemoveEvent(e: any) {
    this.fileUploadData = [];
  }

  onContTypeChange() {
    this.noBankInfo = !(this.contType === 'positive' || (this.isInfoAvailable && this.contType === 'negative'));
    if (!this.noBankInfo) {
      this.noBankInfo = false;
      this.isCurrentFY = '';
      this.isWithheldCont = '';
      if (this.gridData && this.contType) {
        this.gridData.forEach((element, index) => {
          if (element.adjustmentAmount > 0 || this.min > element.adjustmentAmount) {
            this.gridData[index].adjustmentAmount = 0.00;
          }
          this.totalAdjustmentValue();
        });
      }
      if (this.fileUploadData && this.fileUploadData.length > 0) {
        this.uploadFile.clearFiles();
        this.fileUploadData = [];
      }
    }
    if (this.contType && this.contType.length > 0) {
      this.resetEvent.emit(false);
    }
  }

  onChange() {
    if (this.gridData && (this.isWithheldCont === 'no' || this.isCurrentFY === 'no')) {
        this.gridData.forEach((element, index) => {
          if (element.adjustmentAmount > 0 || this.min > element.adjustmentAmount) {
            this.gridData[index].adjustmentAmount = 0.00;
          }
          this.totalAdjustmentValue();
      });
    }
  }

  cancelChanges() {
   this.cancelEvent.emit();
  }

}
